import React, { useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
// import { IdContext } from "./components/Contexts/IdContext";
import { PageNotFound } from "./pages/404";
import { Home } from "./pages/Home";
import AuthGuard from "./AuthGuard";
import LicenseGuard from "./LicenseGuard";
import { LicenseError } from "./pages/LicenseError";

export default function App(){
	// const [id, setId] = useState(null);

	return (
    <Router>
      {/* <IdContext.Provider value={{ id, setId }}> */}
      <Routes>
        <Route exact path="/" element={<Home />}></Route>
        <Route
          exact
          path="/:createID/create"
          element={
            <LicenseGuard>
              <AuthGuard>
                <Home />
              </AuthGuard>
            </LicenseGuard>
          }
        />
        <Route
          exact
          path="/:updateID/update"
          element={
            <LicenseGuard>
              <AuthGuard>
                <Home />
              </AuthGuard>
            </LicenseGuard>
          }
        />
        <Route
          exact
          path="/:sessionId/:apiUrl/:cartKey/:loadCategories/user-edit"
          element={
            <LicenseGuard>
              <Home />
            </LicenseGuard>
          }
        ></Route>
        <Route path="/license-error" element={<LicenseError />} />
        <Route path="/*" element={<PageNotFound />}></Route>
      </Routes>
      {/* </IdContext.Provider> */}
    </Router>
  );
}
